import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RedefineYourRadiance from "./sections/RedefineYourRadiance";
import CuratedExpertise from "./sections/CuratedExpertise";
import TheLookbook from "./sections/TheLookbook";
import WhyWorkWithOpal from "./sections/WhyWorkWithOpal";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import EfficiencyEngagement from "./sections/EfficiencyEngagement";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RedefineYourRadiance />
      <CuratedExpertise />
      <TheLookbook />
      <WhyWorkWithOpal />
      <WhatOurClientsSay />
      <EfficiencyEngagement />
      <Footer />
    </div>;
}